import gql from 'graphql-tag';
import { VendorLayerDetailFragment } from '@/graphql/fragments';

export default gql`
  query nodeQuery($id: ID!) {
    node(id: $id) {
      __typename
      ...VendorLayerDetailFragment
    }
  }
  ${VendorLayerDetailFragment}
`;
